import {FuseNavigation} from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'main_group',
        title: '',
        translate: '',
        type: 'group',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                translate: 'NAV.DASHBOARD',
                type: 'item',
                icon: 'home',
                url: '/dashboard',
            },
            {
                id: 'clients',
                title: 'Clients',
                translate: 'NAV.CLIENTS',
                type: 'item',
                icon: 'group',
                url: '/client-list',
            },
            {
                id: 'contracts',
                title: 'Contracts',
                translate: 'NAV.CONTRACTS.CONTRACTS',
                type: 'group',
                icon: 'description',
                children: [
                    {
                        id: 'contract-list',
                        title: 'List',
                        translate: 'NAV.CONTRACTS.LIST',
                        type: 'item',
                        icon: 'description',
                        url: '/contract-list'
                    },
                    {
                        id: 'contracts-new',
                        title: 'New',
                        translate: 'NAV.CONTRACTS.NEW',
                        type: 'item',
                        icon: 'add',
                        url: '/contract-create'
                    },
                ],
            },
            {
                id: 'advisors',
                title: 'Advisors',
                translate: 'NAV.ADVISORS.ADVISORS',
                type: 'group',
                icon: 'contacts',
                children: [
                    {
                        id: 'applicants-list',
                        title: 'Applicants List',
                        translate: 'NAV.APPLICANTS.LIST',
                        type: 'item',
                        icon: 'contacts',
                        url: '/applicants-list'
                    },
                    {
                        id: 'advisors-list',
                        title: 'List',
                        translate: 'NAV.ADVISORS.LIST',
                        type: 'item',
                        icon: 'contacts',
                        url: '/advisor-list'
                    },
                    {
                        id: 'advisors-tree',
                        title: 'Tree',
                        translate: 'NAV.ADVISORS.TREE',
                        type: 'item',
                        icon: 'device_hub',
                        url: '/advisor-tree'
                    },
                    {
                        id: 'manufactory',
                        title: 'Manufactory',
                        translate: 'NAV.ADVISORS.MANUFACTORY',
                        type: 'item',
                        icon: 'call_split',
                        url: '/manufactory-list'
                    },
                    {
                        id: 'advisor-commision',
                        title: 'Commission',
                        translate: 'NAV.ADVISORS.COMMISSION',
                        type: 'item',
                        icon: 'attach_money',
                        url: '/advisor-commision'
                    },
                    // {
                    //     id: 'advisors-new',
                    //     title: 'New',
                    //     translate: 'NAV.ADVISORS.NEW',
                    //     type: 'item',
                    //     icon: 'add',
                    //     url: '/advisor-new'
                    // },
                ],
            },
            {
                id: 'reports',
                title: 'Reports',
                translate: 'NAV.REPORTS.TITLE',
                type: 'group',
                icon: 'bar_chart',
                children: [
                    {
                        id: 'reports-advisors',
                        title: 'Reports advisors',
                        translate: 'NAV.REPORTS.ADVISORS',
                        type: 'item',
                        icon: 'bar_chart',
                        url: '/reports-advisors'
                    },
                    {
                        id: 'reports-hq',
                        title: 'Reports HQ',
                        translate: 'NAV.REPORTS.HQ',
                        type: 'item',
                        icon: 'bar_chart',
                        url: '/reports-hq'
                    },
                ],
            },
            {
                id: 'devgroup',
                title: 'DEV',
                type: 'group',
                children: [
                    {
                        id: 'devform',
                        title: 'DEV form',
                        type: 'item',
                        icon: 'bug_report',
                        url: '/dev-form'
                    },
                ],
            }
        ],
    }
];
